import * as React from 'react';
import {connect} from "react-redux";
import {CONTACT_TAB} from '../../../Config/appConfig';
import {Auth} from '../../../Config/dataModel';
import authState from '../../../ReduxRequests/State/authState';
import InsurerList from '../CompanyList/InsurerList';
import SubagentList from '../CompanyList/SubagentList';
import Invitation from '../Invitation/Invitation';

interface CompanyControllerProps {
    isInsurer?: () => boolean,
    auth?: () => Auth
}

class CompanyController extends React.Component <CompanyControllerProps, {}> {
    public render() {
        if (this.props.isInsurer()) {
            if (this.props.auth().user.isAdmin) { return (<Invitation currentTab={CONTACT_TAB.COMPANY}/>); }
            return (<SubagentList/>);
        }
        else return (<InsurerList/>);
    }
}

export default connect(authState, null)(CompanyController);



// WEBPACK FOOTER //
// ./src/Components/Contact/ContactController/CompanyController.tsx